module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "height-100"
  }, [(_vm.mostrarModalAsignarAsistenteExterno) ? _c('div', {
    staticClass: "modal is-active",
    class: {
      'modal-sidebar-desktop-open': _vm.showSidebarDesktop
    }
  }, [_c('div', {
    staticClass: "modal-background",
    on: {
      "click": function($event) {
        _vm.mostrarModalAsignarAsistenteExterno = false
      }
    }
  }), _c('div', {
    staticClass: "card"
  }, [_c('header', {
    staticClass: "modal-card-head display-flex"
  }, [_c('p', {
    staticClass: "flex-1"
  }, [(_vm.asistenteExterno.id) ? _c('span', [_vm._v("Actualizar asistente externo")]) : _c('span', [_vm._v("Insertar asistente interno")])])]), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('div', {
    staticClass: "display-flex fdc"
  }, [_c('div', {
    staticClass: "control margin-bottom-10 flex-1"
  }, [_c('p', {
    staticClass: "margin-bottom-5"
  }, [_vm._v("Nombre")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.asistenteExterno.nombreExterno),
      expression: "asistenteExterno.nombreExterno"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "disabled": _vm.isSaving
    },
    domProps: {
      "value": (_vm.asistenteExterno.nombreExterno)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.asistenteExterno, "nombreExterno", $event.target.value)
      }
    }
  })]), _c('div', {
    staticClass: "control margin-bottom-10"
  }, [_c('p', {
    staticClass: "margin-bottom-5"
  }, [_vm._v("Cargo")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.asistenteExterno.cargoExterno),
      expression: "asistenteExterno.cargoExterno"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "disabled": _vm.isSaving
    },
    domProps: {
      "value": (_vm.asistenteExterno.cargoExterno)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.asistenteExterno, "cargoExterno", $event.target.value)
      }
    }
  })])])])]), _c('footer', {
    staticClass: "card-footer"
  }, [_c('a', {
    staticClass: "card-footer-item",
    on: {
      "click": _vm.guardarAsistenteExterno
    }
  }, [(_vm.isSaving) ? _c('strong', [_vm._v("Guardando...")]) : _c('strong', [_vm._v("Guardar")])]), _c('a', {
    staticClass: "card-footer-item",
    on: {
      "click": _vm.closeModalAsignarAsistenteExterno
    }
  }, [_c('span', [_vm._v("Cancelar")])])])])]) : _vm._e(), (_vm.mostrarModalAsignarEmpleado) ? _c('div', {
    staticClass: "modal is-active",
    class: {
      'modal-sidebar-desktop-open': _vm.showSidebarDesktop
    }
  }, [_c('div', {
    staticClass: "modal-background",
    on: {
      "click": function($event) {
        _vm.mostrarModalAsignarEmpleado = false
      }
    }
  }), _c('transition', {
    attrs: {
      "name": "fade-quick"
    }
  }, [_c('seleccionar-empleado', {
    attrs: {
      "fetchEndpoint": _vm.fetchEndpoint,
      "filtroProp": _vm.filtroAsignarEmpleado,
      "asignarEmpleadosEndpoint": _vm.asignarEmpleadosEndpoint,
      "desasignarTodosEndpoint": _vm.desasignarTodosEndpoint,
      "asignarTodosEndpoint": _vm.asignarTodosEndpoint,
      "objAux": _vm.objAux
    },
    on: {
      "close": function($event) {
        return _vm.closeModalAsignarEmpleado()
      }
    }
  })], 1)], 1) : _vm._e(), _vm._m(0), _c('div', {
    staticClass: "text-center"
  }, [(!(_vm.esReunionTerminada || _vm.esReunionAnulada)) ? _c('button', {
    staticClass: "button is-small is-primary mb-5",
    on: {
      "click": function($event) {
        return _vm.abrirModalAsignarEmpleados({})
      }
    }
  }, [_vm._m(1), _c('span', [_vm._v("Asignar Empleados")])]) : _vm._e(), (!(_vm.esReunionTerminada || _vm.esReunionAnulada)) ? _c('button', {
    staticClass: "button is-small is-primary mb-5 ml-5",
    on: {
      "click": function($event) {
        return _vm.abrirModalAsignarAsistenteExterno({})
      }
    }
  }, [_vm._m(2), _c('span', [_vm._v("Agregar Externo")])]) : _vm._e()]), _c('div', {
    staticClass: "body"
  }, [_c('div', {
    staticClass: "data overflow-y-scroll"
  }, [_c('transition-group', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.fetchByScroll),
      expression: "fetchByScroll"
    }],
    staticClass: "contenedor-data",
    attrs: {
      "infinite-scroll-disabled": "disabledScrollExecute",
      "infinite-scroll-distance": "2",
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, _vm._l((_vm.lista), function(o, index) {
    return _c('div', {
      key: 'asistente_' + index,
      staticClass: "asistentes-item position-relative",
      on: {
        "dblclick": function($event) {
          return _vm.abrirModalAsignarEmpleados(o)
        }
      }
    }, [_c('div', {
      staticClass: "asistentes-item-container display-flex"
    }, [_c('div', {
      staticClass: "display-flex fdc flex-1"
    }, [_c('div', {
      staticClass: "asistentes-name"
    }, [_c('span', [_vm._v(_vm._s(o.nombre || o.nombreExterno))])]), _c('div', {
      staticClass: "asistentes-cargo"
    }, [_c('span', [_vm._v(_vm._s(o.cargo || o.cargoExterno))]), (o.externo) ? _c('span', {
      staticClass: "externo-span"
    }, [_vm._v("  (Externo)")]) : _vm._e()])]), _c('div', {
      staticClass: "asistentes-checkbox"
    }, [(o.externo && !_vm.esReunionTerminada && !_vm.esReunionAnulada) ? [_c('button', {
      staticClass: "button is-small m-2",
      on: {
        "click": function($event) {
          return _vm.abrirModalAsignarAsistenteExterno(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-pencil-square-o"
    })])]), _c('button', {
      staticClass: "button is-small m-2 is-danger",
      on: {
        "click": function($event) {
          return _vm.borrarAsistenteExterno(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])] : _vm._e(), (_vm.esReunionTerminada) ? _c('label', {
      staticClass: "checkbox"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (o.asistio),
        expression: "o.asistio"
      }],
      staticClass: "checkbox",
      attrs: {
        "type": "checkbox",
        "name": "asistio",
        "disabled": !_vm.esReunionTerminada || _vm.codigoCreador === o.codigo || _vm.isSaving
      },
      domProps: {
        "checked": Array.isArray(o.asistio) ? _vm._i(o.asistio, null) > -1 : (o.asistio)
      },
      on: {
        "change": [function($event) {
          var $$a = o.asistio,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(o, "asistio", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(o, "asistio", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(o, "asistio", $$c)
          }
        }, function($event) {
          return _vm.changeCheckbox($event, o)
        }]
      }
    }), _c('span', {
      staticClass: "ml-5"
    }, [_vm._v("Asistió")])]) : _vm._e()], 2)])])
  }), 0), (_vm.lista.length === 0) ? _c('div', {
    key: "message_warning"
  }, [_vm._m(3)]) : _vm._e(), (_vm.isLoading) ? _c('div', {
    key: "loading_spin",
    staticClass: "is-loading"
  }, [_vm._m(4)]) : _vm._e()], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title pt-5"
  }, [_c('span', [_vm._v("Asistentes")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-users is-small"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-users is-small"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "message is-warning"
  }, [_c('div', {
    staticClass: "message-body"
  }, [_vm._v("No hay alumnos registrados")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ab169f18","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Lista_Asistentes_Empleados_Multiple.vue
// module id = 940
// module chunks = 0